type StringOrNumber = string | number;
type StringOrObject = string | CertificateLinkName;

enum EducationFormList {
  FULL_TIME = 'очная',
  PART_TIME = 'очно-заочная',
  EXTRAMURAL = 'заочная',
  DISTANCE = 'дистанционная',
}

interface QueryMunicipality {
  municipality: string;
}

interface CertificateLinkName {
  name: string;
}

interface QuestionLinkHash {
  hash: string;
}

interface MunicipalityLinkQuery extends CertificateLinkName {
  query: QueryMunicipality;
}

interface PartnerLinkQuery extends QueryMunicipality {
  organizer: string;
}

interface PartnerLinkTypes extends CertificateLinkName {
  query: PartnerLinkQuery;
  params: any;
  path: string;
}

interface PropsFields {
  geo: Locations;
  title: string;
  locations: Locations;
  municipalityLink: Array<MunicipalityLinkQuery>;
  municipalityName: Array<string>;
  educationForm: string;
  laborProgram: string;
  educationMode: string;
  educationCategory: string;
  finishResult: string;
  questionLink: QuestionLinkHash;
  partnerLink: PartnerLinkTypes;
  partnerName: string;
  partnerId: string;
  partnerPhone: string;
  partnerEmail: string;
  isOvz: boolean;
  ovzDiseases: Array<string>;
  cost: string;
  isFree: boolean;
  isOpen: boolean;
  eduDocName: string;
}

interface ComponentProps extends PropsFields {
  disease: string;
  metro: string;
}

interface Location {
  lat?: string;
  lng?: string;
  location: string;
}

type Locations = Array<Location>;

export {
  StringOrNumber,
  StringOrObject,
  EducationFormList,
  QuestionLinkHash,
  MunicipalityLinkQuery,
  PartnerLinkTypes,
  PropsFields,
  ComponentProps,
  Locations,
  Location,
};



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/sidebar/types.ts